var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { Box, Center, Stack, Spacer, Text, useSlotRecipe, } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useContext } from "react";
import { FooterLinks } from "./FooterLinks";
import { SocialLinks } from "./SocialLinks";
export function Footer() {
    var footerRecipe = useSlotRecipe({ key: "Footer" });
    var recipeProps = footerRecipe.splitVariantProps({})[0];
    var styles = footerRecipe(recipeProps);
    var name = useContext(GlobalContext).properties.name;
    return (_jsx(Center, __assign({ as: "footer", css: styles.wrapper, id: "job-board-footer" }, { children: _jsxs(Box, __assign({ css: styles.content }, { children: [_jsxs(Stack, __assign({ direction: ["column", "row"] }, { children: [_jsx(Text, { children: "\u00A9 ".concat(dayjs().year(), " Indeed") }), _jsx(FooterLinks, {}), _jsx(Spacer, {}), _jsx(SocialLinks, {})] })), _jsxs(Text, { children: [name, ", powered by Indeed. For more details on how Indeed uses cookies and protects your personal data, please review their Cookie Policy and Privacy Policy."] })] })) })));
}
